import React from 'react';
import { cn } from '@/utils/styles';

interface ProgressBarProps {
  progress: number; // Progress percentage (0 to 100)
  color: string; // Tailwind color class or custom hex color
  glow?: boolean; // Whether to apply a glowing effect
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  color,
  glow = true,
}) => {
  return (
    <div className="relative w-full h-[5px] rounded-full bg-black overflow-hidden">
      {/* Background Glow */}
      {glow && (
        <div
          className={cn(
            'absolute top-0 left-0 w-full h-full opacity-25',
            'blur-lg',
            color,
          )}
        />
      )}

      {/* Progress Bar */}
      <div
        className={cn(
          `absolute top-0 left-0 h-full rounded-none transition-all duration-300 border-[2px]`,
          glow ? 'shadow-lg' : '',
          color?.startsWith('#') ? `border-${color}` : '',
        )}
        style={{
          width: `${progress}%`,
          backgroundColor: color?.startsWith('#') ? color : undefined,
        }}
      />
    </div>
  );
};

export default ProgressBar;